export default "__VITE_ASSET__Bb_Z6hKA__"